// extracted by mini-css-extract-plugin
export default {"root":"_2i8Y0","top-zone":"_3BapV","topZone":"_3BapV"};